import React from "react";
import config from "../config/config";
import toast from "react-hot-toast";

const AddNetworkButton = () => {
    const addNetwork = async () => {
        const chainParams = {
            chainId: config.chainId,
            chainName: config.chainName || "Anannta Chain",
            nativeCurrency: {
                name: config.nativeCurrencyName || "Anannta Chain",
                symbol: config.nativeCurrencySymbol || "ANANT",
                decimals: config.nativeCurrencyDecimals || 18,
            },
            rpcUrls: [config.rpcUrl],
            blockExplorerUrls: [config.ananntaScanUrl],
        };
        // ✅ First, check the current chain
        let currentChainId = await window.ethereum.request({
            method: "eth_chainId"
        });
        if (currentChainId.toLowerCase() === config.chainId.toLowerCase()) {
            toast.success("Anannta network is already connected.");
            return;
        }

        if (window.ethereum) {
            try {
                await window.ethereum.request({
                    method: 'wallet_addEthereumChain',
                    params: [
                        chainParams,
                    ],
                });
            } catch (error) {
                console.error('Error adding network:', error);
            }
        } else {
            alert('MetaMask is not installed. Please install it first.');
        }
    };

    return (
        <button
            onClick={addNetwork}
            type="button"
            className="btn-01 px-4 btn btn-primary mt-2 w-100"
        >
            <img
                className="me-1"
                width="18"
                src="assets/images/metamask_icon.png"
                alt="Metamask"
            />
            Add Anannta Network
        </button>
    );
};

export default AddNetworkButton;
